<template>
    <div style="height: 98%;">
        <el-row type="flex" style="height: 40px;line-height: 40px;">
            <el-col :span="14">
                <div class="crumbs mcrumb-self">
                    <el-breadcrumb separator="-">
                        <el-breadcrumb-item>
                            <i class="el-icon-user"></i><span>系统设置</span>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item><span>集团用户</span></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </el-col>
            <el-col :span="10">
                <div style="text-align: right;line-height: 32px;">
                    <span style="color: #606266;padding-right: 15px;">当前集团</span>
                    <el-select v-model="currGroupId" @change="currGroupSelectChange" placeholder="请选择" style="width: 365px;">
                        <el-option
                            v-for="item in allGroupComboData"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </el-col>
        </el-row>
        <!-- <el-divider></el-divider> -->
        <div class="container" style="padding: 15px;height: 92%;">
            <div style="padding-bottom: 10px;">
                <el-row type="flex">
                    <el-col :span="8">
                        <el-button type="primary" style="width: 80px" @click="groupUserOperateClickFun('0', '')">新增</el-button>
                        <el-button plain style="width: 80px" @click="deleteGroupUsersClickFun()">删除</el-button>
                    </el-col>
                    <el-col :span="16" style="text-align: right;">
                        <el-input v-model="groupUserSearchName" placeholder="搜索姓名、用户名、手机、邮箱、所属集团名称" @keyup.native="advanceQueryGroupUserData" prefix-icon="el-icon-search" style="width: 350px"/>
                    </el-col>
                </el-row>
            </div>
            <div style="height: 94%;">
                <el-table :data="groupUserTableData" border stripe height="90%" class="table" @row-dblclick="viewGroupUserDetail" ref="groupUserTable" @row-click="clickRowByChecked">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="id" v-if="showColumn"></el-table-column>
                    <el-table-column prop="userName" label="姓名" sortable width="100"></el-table-column>
                    <el-table-column prop="userCode" label="用户名" sortable width="100"></el-table-column>
                    <el-table-column prop="companyNames" label="关联实体" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="roleName" label="用户角色" sortable width="110"></el-table-column>
                    <el-table-column prop="state" label="状态" :formatter="formatStatus" width="80"></el-table-column>
                    <el-table-column prop="companyGroupName" label="所属集团" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="companyGroupCode" label="集团编号" sortable width="120"></el-table-column>
                    <el-table-column prop="companyGroupStatus" label="集团状态" :formatter="this.formatStatus" width="80"></el-table-column>
                    <el-table-column prop="phone" label="手机" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="email" label="邮箱" sortable show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operate" label="操作" width="120" align="center" fixed="right">
                        <template slot-scope="scoped">
                            <el-button size="small" type="text" @click="groupUserOperateClickFun('2', scoped.row)">查看</el-button>
                            <el-button size="small" type="text" @click="groupUserOperateClickFun('1', scoped.row)">编辑</el-button>
                            <el-button size="small" type="text" @click="deleteGroupUserClickFun(scoped.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pwm.page"
                        :page-size="pwm.limit"
                        :page-sizes="pwm.limits"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pwm.count">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 查看、编辑、新增用户 -->
        <el-dialog :title="groupUserOperateTitle" :visible.sync="groupUserOperateDialogVisible" width="55%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form :model="groupUserManageForm" ref="groupUserManageForm" :rules="groupUserFormRule" style="width: 98%;">
                    <el-input v-if="hideId == true" v-model="groupUserManageForm.id"></el-input>
                    <el-input v-if="hideId == true" v-model="groupUserManageForm.companyGroupId"></el-input>
                    <div style="padding-bottom: 15px;">
                        <div style="display: flex;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 姓名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userName">
                                        <el-input v-model="groupUserManageForm.userName" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userCode">
                                        <el-input v-model="groupUserManageForm.userCode"  :disabled="disabledUserCode"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                         <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>手机号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="phone">
                                        <el-input v-model="groupUserManageForm.phone" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>邮箱</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="email">
                                        <el-input v-model="groupUserManageForm.email" :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 密码</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="password">
                                        <el-input v-model="groupUserManageForm.password" show-password :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 确认密码</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="repassword">
                                        <el-input v-model="groupUserManageForm.repassword" show-password :disabled="disabled"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>用户类型</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userType">
                                        <el-select v-model="groupUserManageForm.userType" placeholder="请选择" style="width: 100%;" disabled>
                                            <el-option
                                                v-for="item in this.userTypeData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户角色</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="roleId">
                                        <el-select v-model="groupUserManageForm.roleId" placeholder="请选择" style="width: 100%;" disabled>
                                            <el-option
                                                v-for="item in roleComboData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupName">
                                        <el-input v-model="groupUserManageForm.groupName" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" pro="groupNo">
                                        <el-input v-model="groupUserManageForm.groupNo" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>当前状态</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="state">
                                        <el-select v-model="groupUserManageForm.state" placeholder="请选择" style="width: 100%;" :disabled="disabled">
                                            <el-option
                                                v-for="item in statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;"></div>
                        </div>
                    </div>
                    <div style="padding-left: 15px;">
                        <span class="ar-title">关联实体信息</span>
                        <div style="padding-top: 10px;" v-if="showRelCompanyOpBtn == true">
                            <el-button plain style="width: 80px;" @click="addRelCompanyClickFun()">添加</el-button>
                            <el-button plain style="width: 80px;" @click="delRelCompanyClickFun()">删除</el-button>
                        </div>
                        <div style="padding-top: 10px;">
                            <el-table :data="groupUserManageForm.companyUsers" border stripe height="250px" class="table" ref="relCompanyTable" @row-click="clickUserRelCompanyRowByChecked">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="id" v-if="showColumn"></el-table-column>
                                <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveGroupUserDataClickFun('groupUserManageForm')" style="width: 80px;" v-if="showOpBtn">保存</el-button>
                <el-button @click="groupUserOperateDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>

        <el-dialog title="公司信息" :visible.sync="showCompanyDataDialogVisible" width="40%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <div style="padding-top: 10px;">
                    <el-table :data="userRelCompanyData" border stripe height="300px" class="table" ref="companyTable" @row-click="clickCompanyTableRowByChecked">
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="id" v-if="showColumn"></el-table-column>
                        <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserRelCompanyClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="showCompanyDataDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        data() {
            return {
                pwm: JSON.parse(JSON.stringify(this.pageobj)),
                groupUserSearchName: '',
                currGroupId: '',    //  当前集团 ID
                currGroupData: '',  //  当前所选集团信息
                allGroupData: [],
                allGroupComboData: [],
                showColumn: false,  //  id列是否隐藏
                showRelCompanyOpBtn: false, //  关联实体公司信息操作按钮是否显示
                showOpBtn: false, //    新增、编辑、查看用户-保存按钮是否显示
                hideId: false,
                groupUserTableData: [],
                groupUserOperateTitle: '',
                groupUserOpUrl: '',
                groupUserOperateDialogVisible: false,
                roleComboData: [],  //  用户角色下拉数据
                roleData: [],   //  当前集团下所有的用户角色
                groupUserManageForm: {
                    userName: '',
                    phone: '',
                    userCode: '',
                    email: '',
                    password: '',
                    repassword: '',
                    userType: '',
                    roleId: '',
                    groupName: '',
                    groupNo: '',
                    status: '0',
                    companyUsers: []
                },
                groupUserFormRule: {    //  form 校验
                    userName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { max: 10, message: '姓名不得超过10个字符' }
                    ],
                    userCode: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                        { max: 40, message: '用户名不得超过40个字符' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 6, max: 30, message: '密码错误，长度为6~30位之间' }
                    ],
                    repassword: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { validator: this.checkPassword, trigger: 'blur'}
                    ],
                    phone: [
                        { required: false, validator: this.checkMobile }
                    ],
                    email: [
                        {  required: false, validator: this.checkEmail }
                    ],
                    roleId: [
                        { required: true, message: '请选择用户角色', trigger: 'change' }
                    ]
                },
                userRelCompanyData: [],
                showCompanyDataDialogVisible: false,
                allCompanyList: [], //  当前集团下所有实体信息
                disabled: false,    //  字段是否禁用
                disabledUserCode: false,    //  用户名是否禁用
            }
        },
        created: function() {
            this.getAllGroupData().then((val) => {
                this.getGroupUserTableData();   //  load user table data
            });
        },
        mounted: function() {
            // this.loadGroupUserTableData();
        },
        methods: {
            handleSizeChange(val) {
                this.pwm.limit = val;
                this.getGroupUserTableData();
            },
            handleCurrentChange(val) {
                this.pwm.page = val;
                this.getGroupUserTableData();
            },
            clickRowByChecked(row) {
                this.$refs.groupUserTable.toggleRowSelection(row);
            },
            clickUserRelCompanyRowByChecked(row) {
                this.$refs.relCompanyTable.toggleRowSelection(row);
            },
            clickCompanyTableRowByChecked(row) {
                this.$refs.companyTable.toggleRowSelection(row);
            },
            async getAllGroupData() {   //  获取所有集团数据
                await fetchPost('/sys/admin/getAllCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        let groupData = res.data.obj;
                        this.allGroupData = res.data.obj;
                        let groupCmoboData = [];
                        groupCmoboData.push({value: -1, label: '所有'});
                        if(groupData && groupData.length > 0) {
                            groupData.forEach(group => {
                                groupCmoboData.push({value: group.id, label: group.name});
                            });
                        }
                        this.allGroupComboData = groupCmoboData;
                        this.currGroupId = -1;
                    } else {
                        this.$message.error('获取所有集团信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取所有集团信息失败：' + error);   
                });
            },
            getGroupUserTableData: function() {    //  load table data
                this.pwm.search = { 'groupId':  this.currGroupId };
                this.pwm.likeSearch = this.groupUserSearchName;
                this.pwm.page = 1;
                this.pwm.limit = 10;
                fetchPost('/sys/admin/getUserList', this.pwm).then(res => {
                    this.groupUserTableData = res.data.data;
                    this.pwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载用户信息失败：' + error);
                });
            },
            currGroupSelectChange(newVal) { //  当前集团 select change事件
                let groupData = JSON.parse(JSON.stringify(this.allGroupData));
                this.currGroupData = groupData.filter(group => { return newVal == group.id; })
                this.currGroupId = newVal;

                this.getCompanyDataByCurrGroupId(this.currGroupId);

                this.getGroupUserTableData();   //  load curr group company datat
            },
            async getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
                await fetchPost('/sys/admin/getCompanyListByGroup', groupId).then(res => {
                    if(res.data.success) {
                        this.allCompanyList = res.data.obj;
                    } else {res.data.data;
                        this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取当前集团下所有实体信息失败：' + error);
                });
            },
            async getRoleListByGroupId(groupId) { //  获取当前集团下的所有用户角色数据
                let roleData = [];
                await fetchPost('/sys/admin/getRoleListByCompanyGroup', groupId).then(res => {
                    if(res.data.success) {
                        roleData = res.data.obj;
                        this.assembleRoleComboData(res.data.obj);
                    } else {
                        this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载当前集团下用户角色信息错误：' + error);
                });
                return roleData;
            },
            async assembleRoleComboData(roleData) {   //  拼接用户角色下拉数据
                let roleComboData = [];
                if(roleData && roleData.length > 0) {
                    roleData.forEach(role => {
                        roleComboData.push({value: role.id, label: role.roleName});
                    });
                }
                this.roleComboData = roleComboData;
            },
            getUserDataById(rowData) {   //  查看详情
                fetchPost('/sys/admin/getUserById', rowData.id).then(res => {
                    if(res.data.success) {
                        let objList =res.data.obj
                        objList.repassword=objList.password
                        this.groupUserManageForm = objList ;
                        this.groupUserManageForm.groupName = objList.companyGroupName;
                        this.groupUserManageForm.groupNo = objList.companyGroupCode;
                        this.groupUserManageForm.companyUsers = objList.companyList;
                        this.groupUserOperateDialogVisible = true;
                    } else {
                        this.$message.error('加载用户信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载用户信息失败：' + error);
                });
            },
            advanceQueryGroupUserData() {   //  高级查询
                this.getGroupUserTableData();
            },
            groupUserOperateClickFun(opType, rowData) {  //  新增、编辑、查看 dialog
                Object.keys(this.groupUserManageForm).map(key => (this.groupUserManageForm[key] = ''));
                this.groupUserManageForm.companyUsers = [];
                this.$nextTick(() => {
                    if(this.$refs.groupUserManageForm) {
                        this.$refs.groupUserManageForm.clearValidate();   //  重置表单校验
                    }
                });
                if(opType == '0') {
                    if(!this.currGroupId || this.currGroupId == '-1') {
                        this.$message.warning('请选择所属集团进行新增操作！');
                        return;
                    }
                    this.getCompanyDataByCurrGroupId(this.currGroupId).then((val) => {
                        this.getRoleListByGroupId(this.currGroupId).then(roleData => {
                            //  新增集团用户：默认角色为集团管理员
                            let roleDataList = roleData.filter(roleObj => {
                                return roleObj.roleName == '集团管理员';
                            })
                            if(roleDataList && roleDataList.length > 0) {
                                this.groupUserManageForm.roleId = roleDataList[0].id;
                            }
                        });
                    });
                } else {
                    this.getCompanyDataByCurrGroupId(rowData.companyGroupId).then((val) => {
                        this.getRoleListByGroupId(rowData.companyGroupId);
                    });
                }
                if(opType == '0') {
                    this.groupUserOperateTitle = '新增用户';
                    this.showOpBtn = true;
                    this.showRelCompanyOpBtn = true;
                    this.disabled = false;
                    this.disabledUserCode = false;

                    this.groupUserManageForm.state = '0';
                    this.groupUserManageForm.groupName = this.currGroupData[0].name;
                    this.groupUserManageForm.groupNo = this.currGroupData[0].code;
                    this.groupUserManageForm.userType = '1';    //  默认集团管理员
                    this.groupUserOpUrl = '/sys/admin/addUser';

                    this.groupUserOperateDialogVisible = true;
                } else if(opType == '1') {
                    this.groupUserOperateTitle = '编辑用户'
                    this.showOpBtn = true;
                    this.showRelCompanyOpBtn = true;
                    this.disabled = false;
                    this.disabledUserCode = true;

                    this.getUserDataById(rowData);
                    this.groupUserOpUrl = '/sys/admin/updateUser';
                } else {
                    this.groupUserOperateTitle = '查看详情';
                    this.showOpBtn = false;
                    this.showRelCompanyOpBtn = false;
                    this.disabled = true;
                    this.disabledUserCode = true;

                    this.getUserDataById(rowData);
                }
            },
            addRelCompanyClickFun() {   //  新增用户关联公司信息
                this.showCompanyDataDialogVisible = true;
                //  过滤掉用户已关联的实体信息
                this.userRelCompanyData = this.allCompanyList.filter(company => {
                    let checkIdList = this.groupUserManageForm.companyUsers.map(data => data.id);
                    return !checkIdList .includes(company.id)
                })
            },
            delRelCompanyClickFun() {   //   删除用户关联公司信息
                let checkRows = this.$refs.relCompanyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除关联的公司信息！');
                    return;
                }

                //  过滤掉用户已关联的实体信息
                this.userRelCompanyData = this.allCompanyList.filter(company => {
                    let checkIdList = this.groupUserManageForm.companyUsers.map(data => data.id);
                    return !checkIdList .includes(company.id)
                })

                let relCompanyData = this.groupUserManageForm.companyUsers;
                this.groupUserManageForm.companyUsers = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                this.allCompanyList = this.userRelCompanyData.concat(checkRows);
            },
            saveUserRelCompanyClickFun() {  //  保存用户勾选的公司信息
                let checkRows = this.$refs.companyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要关联的公司信息！');
                    return;
                }
                let relCompanyData = this.userRelCompanyData;
                this.allCompanyList = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                this.groupUserManageForm.companyUsers = this.groupUserManageForm.companyUsers.concat(checkRows);
                this.showCompanyDataDialogVisible = false;
            },
            viewGroupUserDetail(row, column, event) {    //  双击即查看
                this.groupUserOperateClickFun('2', row);
            },
            saveGroupUserDataClickFun(formName) {   //  save / update
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let userData = this.groupUserManageForm;
                    if(this.currGroupId == '-1') {
                        userData.companyGroupId = this.groupUserManageForm.companyGroupId;
                    } else {
                        userData.companyGroupId = this.currGroupId;
                    }
                    let companyIdList = [];
                    let userCheckCompanyData = userData.companyUsers;
                    if(!userCheckCompanyData || userCheckCompanyData.length == 0) {
                        this.$message.warning('请选择用户所关联的实体信息！');
                        return;
                    }
                    userCheckCompanyData.forEach(company => {
                        companyIdList.push(company.id);
                    });
                    userData.companyIds = companyIdList.join(',');
                    let companyUsers = JSON.parse(JSON.stringify(userData.companyUsers));
                    delete userData.companyUsers;

                    fetchPost(this.groupUserOpUrl, userData).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存用户信息成功！');
                            this.groupUserOperateDialogVisible = false;   //  关闭dialog
                            //  reload user table
                            this.getGroupUserTableData();
                        } else {
                            this.$message.error('保存用户信息失败：' + res.data.message);   
                            this.groupUserManageForm.companyUsers = companyUsers;
                        }
                    }, error => {
                        this.$message.error('保存用户信息失败：' + error);
                    });
                })
            },
            deleteGroupUsersClickFun() {    //  batch delete users
                 if(!this.currGroupId || this.currGroupId == '-1') {
                    this.$message.warning('请选择所属集团进行新增操作！');
                    return;
                }

                let idList = [];
                let checkRows = this.$refs.groupUserTable.selection;
                 if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除的用户信息！');
                    return;
                }
                checkRows.forEach(row => {
                    idList.push(row.id);
                });
                this.$confirm('是否删除当前选中实体信息？', '提示', { type: 'warning'}).then(res => {
                    this.deleteUser(idList.join(','));
                });
            },
            deleteGroupUserClickFun(rowData) { //  单行删除
                this.$confirm('是否删除当前选中实体信息？', '提示', { type: 'warning'}).then(res => {
                    this.deleteUser(idList.join(','));
                });
            },
            deleteUser(ids) {  //  删除操作
                fetchPost('/sys/admin/deleteUsers', ids).then(res => {
                    if(res.data.success) {
                        this.$message.success('删除用户信息成功！');
                        //  reload user table
                        this.getGroupUserTableData();
                    } else {
                        this.$message.error('删除用户信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('删除用户信息失败：' + error);
                });
            },
            checkPassword(rule, value, cb) {    //  确认密码校验
                if(this.groupUserManageForm.password != value) {
                    cb(new Error('确认密码与密码不一致'));
                } else {
                    return cb()
                }
            },
            formatRoleType(row, column, cellValue, index) {  //  format 角色类型： 1 - 集团管理员 2 - 集团用户
                if(cellValue == '1') {
                    return '集团管理员';
                } else if(cellValue == '1') {
                    return '集团用户';
                } else {
                    return '';
                }
            }
        }
    }
</script>

<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
</style>